import _toConsumableArray from '@babel/runtime-corejs3/helpers/toConsumableArray';
import _asyncToGenerator from '@babel/runtime-corejs3/helpers/asyncToGenerator';
import _slicedToArray from '@babel/runtime-corejs3/helpers/slicedToArray';
import _concatInstanceProperty from '@babel/runtime-corejs3/core-js/instance/concat';
import _mapInstanceProperty from '@babel/runtime-corejs3/core-js/instance/map';
import _regeneratorRuntime from '@babel/runtime-corejs3/regenerator';
import React__default, { useState } from 'react';
import { api } from '@bilibili-maoer/web-utils';
import useMount from 'react-use/lib/useMount';
import '../../../../../lazy-image/legacy-lazy-image/index.js';
import { SquareLazyImage } from '../../../../../lazy-image/lazy-image/index.js';
import { Loading, ELoadingType } from '../../../../../loading/index.js';
import '../../../../../scrollable/legacy-scrollable/index.js';
import { Scrollable } from '../../../../../scrollable/scrollable/index.js';
import '../../../../../utils/fetcher.js';
import { prependPrefix } from '../../../../../utils/style.js';
import { getFeed } from '../../../api/feed.js';
import { THROTTLE_DELAY_MS } from '../../../consts.js';
import { FEED_PAGE_URL } from '../../../url.js';
import { FailedNotice } from './notice.js';

var feedCache = []; // 缓存获取首页数据的时间戳，用于节流

var lastFirstPageFeedRequestTime = 0;
var Feed = function Feed() {
  /**
   * 由于动态需要实时更新，所以初始化 feed 时 hasMore 始终设置为 true
   * 例：首次请求时，请求了 9 条数据，此时接口返回 hasMore 为 false，如果缓存了实际的 hasMore，但此时动态更新为了 11 条，
   *    再次打开动态下拉框时，就不会请求下一页数据了，所以将其写死为 true。
   */
  var _useState = useState({
    hasMore: true,
    msg: feedCache
  }),
      _useState2 = _slicedToArray(_useState, 2),
      feed = _useState2[0],
      setFeed = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      loading = _useState4[0],
      setLoading = _useState4[1];

  var _useState5 = useState(true),
      _useState6 = _slicedToArray(_useState5, 2),
      initSuccess = _useState6[0],
      setInitSuccess = _useState6[1]; // 初始化并缓存首页动态数据


  var initFirstPageFeed = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _res$info, _res$info2, res, msg, hasMore;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // 通过 lastFirstPageFeedRequestTime 判断 feedCache 是否缓存过，存在缓存时再次调用 initFirstPageFeed 不显示 loading
              if (!lastFirstPageFeedRequestTime) {
                setLoading(true);
                setInitSuccess(true);
              } // 获取首页数据时，id 传空


              _context.prev = 1;
              _context.next = 4;
              return getFeed();

            case 4:
              res = _context.sent;
              msg = ((_res$info = res.info) === null || _res$info === void 0 ? void 0 : _res$info.msg) || [];
              hasMore = !!((_res$info2 = res.info) !== null && _res$info2 !== void 0 && _res$info2.hasMore);
              feedCache = msg;
              setFeed({
                hasMore: hasMore,
                msg: msg
              });
              setLoading(false);
              setInitSuccess(true);
              return _context.abrupt("return", true);

            case 14:
              _context.prev = 14;
              _context.t0 = _context["catch"](1);
              setLoading(false);
              setInitSuccess(false);
              return _context.abrupt("return", false);

            case 19:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 14]]);
    }));

    return function initFirstPageFeed() {
      return _ref.apply(this, arguments);
    };
  }(); // 下拉加载动态数据


  var onGetFeedData = function onGetFeedData() {
    var _feed$msg, _feed$msg2;

    if (!feed.hasMore || loading) {
      return;
    } // 获取非首页数据时，需要传递上一页最后一条数据的 id


    var id = feed === null || feed === void 0 ? void 0 : (_feed$msg = feed.msg) === null || _feed$msg === void 0 ? void 0 : (_feed$msg2 = _feed$msg[feed.msg.length - 1]) === null || _feed$msg2 === void 0 ? void 0 : _feed$msg2.id;
    setLoading(true);
    getFeed(id).then(function (res) {
      var _res$info3, _context2, _res$info4;

      var hasMore = !!((_res$info3 = res.info) !== null && _res$info3 !== void 0 && _res$info3.hasMore);
      setFeed({
        hasMore: hasMore,
        msg: _concatInstanceProperty(_context2 = []).call(_context2, _toConsumableArray((feed === null || feed === void 0 ? void 0 : feed.msg) || []), _toConsumableArray(((_res$info4 = res.info) === null || _res$info4 === void 0 ? void 0 : _res$info4.msg) || []))
      });
      setLoading(false);
    }).catch(function () {
      setLoading(false);
    });
  };

  useMount(function () {
    // 防止频繁 hover 导致 /mperson/getfeed 接口高频请求
    if (Date.now() - lastFirstPageFeedRequestTime > THROTTLE_DELAY_MS) {
      initFirstPageFeed().then(function (success) {
        if (success) {
          // 首页数据更新成功后，同步时间戳
          lastFirstPageFeedRequestTime = Date.now();
        }
      });
    }
  });

  var renderFeed = function renderFeed() {
    var _context3;

    if (loading) {
      return /*#__PURE__*/React__default.createElement(Loading, {
        className: "history-loading",
        type: ELoadingType.MGirl
      });
    }

    if (!initSuccess) {
      return /*#__PURE__*/React__default.createElement(FailedNotice, null);
    }

    if (!feed.msg.length) {
      return /*#__PURE__*/React__default.createElement("div", {
        className: "history-empty"
      }, "\u8FD8\u6CA1\u6709\u52A8\u6001\u5462~");
    }

    return /*#__PURE__*/React__default.createElement("div", {
      className: "feed-list-wrapper"
    }, _mapInstanceProperty(_context3 = feed.msg).call(_context3, function (item) {
      var _context4, _context5, _context6, _context7;

      return /*#__PURE__*/React__default.createElement("div", {
        className: "feed-item",
        key: item.id
      }, /*#__PURE__*/React__default.createElement(SquareLazyImage, {
        className: "feed-cover",
        alt: item.soundstr,
        src: item.front_cover
      }), /*#__PURE__*/React__default.createElement("div", {
        className: "feed-detail"
      }, !!item.dramaid && /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("span", null, "\u5267\u96C6"), /*#__PURE__*/React__default.createElement("a", {
        target: "_blank",
        href: _concatInstanceProperty(_context4 = "".concat(api.MISSEVAN_SITE_MAIN, "/mdrama/")).call(_context4, item.dramaid),
        title: item.drama_name
      }, item.drama_name), /*#__PURE__*/React__default.createElement("span", null, "\u66F4\u65B0\u81F3\uFF1A")), !!item.channelid && /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("span", null, "\u9891\u9053"), /*#__PURE__*/React__default.createElement("a", {
        target: "_blank",
        href: _concatInstanceProperty(_context5 = "".concat(api.MISSEVAN_SITE_MAIN, "/explore/channel/")).call(_context5, item.channelid),
        title: item.tag
      }, item.tag), /*#__PURE__*/React__default.createElement("span", null, "\u65B0\u6536\u5F55\u4E86\uFF1A")), !item.dramaid && !item.channelid && /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("a", {
        target: "_blank",
        href: _concatInstanceProperty(_context6 = "".concat(api.MISSEVAN_SITE_MAIN, "/")).call(_context6, item.user_id),
        title: item.username
      }, item.username), /*#__PURE__*/React__default.createElement("span", null, "\u6295\u7A3F\u4E86\uFF1A")), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("a", {
        target: "_player",
        href: _concatInstanceProperty(_context7 = "".concat(api.MISSEVAN_SITE_MAIN, "/sound/")).call(_context7, item.id),
        title: item.soundstr
      }, item.episode_name || item.soundstr))));
    }), loading && /*#__PURE__*/React__default.createElement(Loading, {
      className: "history-loading",
      type: ELoadingType.MGirl
    }));
  };

  return /*#__PURE__*/React__default.createElement("div", {
    className: prependPrefix('popup')
  }, /*#__PURE__*/React__default.createElement(Scrollable, {
    className: prependPrefix('feed-scrollable'),
    onReachEnd: onGetFeedData
  }, renderFeed()), /*#__PURE__*/React__default.createElement("a", {
    className: prependPrefix('more'),
    target: "_blank",
    href: FEED_PAGE_URL
  }, "\u67E5\u770B\u66F4\u591A"));
};

export { Feed };
